import React from "react";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { ProductConsumer } from "../../../Context/AddProWakel";
const FillDetailKoga3arz = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            HK_name,
            HK_code,
            HK_draw,
            getPrint,
            HK_OpenModal,
            L_user,
            HK_pshandan
          } = value;
          return (
            <>
              <div className="row" style={{ backgroundColor: "#2C3539" }}>
                <div className="col-lg-3 col-5 form-inline">
                  <div className="row form-inline">
                    <div className="col-12 form-inline">
                      <span style={{ color: "#2C3539" }}>:</span>
                      <select
                        className={`form-control text-right font-weight-bold selectpicker pull-right ${
                          HK_draw == "دۆلار"
                            ? "bg-success text-white"
                            : `${
                                HK_draw == "دینار" ? "bg-danger text-white" : ""
                              }`
                        }`}
                        onChange={AddProChange}
                        name="HK_draw"
                        value={HK_draw != null ? HK_draw : ""}
                      >
                        <option className="ml5">جۆری دراو</option>
                        <option>دۆلار</option>
                        <option>دینار</option>
                      </select>
                      <Link to="/print-3arz" onClick={getPrint}>
                        <button className="btn btn-warning ml-4">چاپ</button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-9 col-7  mt3">
                  <div className="row">
                    <div className="col-3">
                      <input
                        type="text"
                        name="HK_name"
                        value={HK_name}
                        onChange={AddProChange}
                        aria-label="Large"
                        className="form-control"
                        placeholder="گەڕان بە ناو"
                      />
                    </div>
                    <div className="col-3">
                      <input
                        type="text"
                        name="HK_code"
                        value={HK_code}
                        onChange={AddProChange}
                        aria-label="Large"
                        className="form-control"
                        placeholder="گەڕان بە کۆد"
                      />
                    </div>
                    <div className="col-1">
                      <label className="text-warning f4 font-weight-bold">
                        گەڕان
                      </label>
                    </div>
                    <div className="col-2 ml2">
                      <button
                        className="btn btn-warning ml-4"
                        onClick={(e) => HK_OpenModal(e, L_user._id)}
                      >
                        پسولەی عەرز
                      </button>
                    </div>
                    <div className="col-1">
                      <button
                        className="btn btn-info "
                        onClick={(e) => HK_pshandan(e)}
                      >
                        هەموو
                      </button>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FillDetailKoga3arz;
